export default function getPageTypeLabel(page) {
  if (page?.type === 'event') {
    return 'event';
  }

  if (page?.type === 'form') {
    return 'form';
  }

  return 'checkout page';
}

export function getPageTypeHeading(page) {
  const label = getPageTypeLabel(page);
  return label.charAt(0).toUpperCase() + label.slice(1);
}
